import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import { useTrpc } from '~/composables/_next/useTrpc';
import { useLocalization } from '~/composables/_next/useLocalization';
export function useProductsMinimalFromSkus(skus) {
  var _useLocalization = useLocalization(),
    locale = _useLocalization.locale;
  var _useTrpc = useTrpc(),
    client = _useTrpc.client;
  var products = useState("useProductsMinimalFromSkus-products-".concat(skus.toString()), function () {
    return [];
  });
  function search() {
    return _search.apply(this, arguments);
  }
  function _search() {
    _search = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return client.commercetools.getProductsMinimalFromSkus.query({
              skus: skus,
              locale: locale
            });
          case 3:
            products.value = _context.sent;
            _context.next = 10;
            break;
          case 6:
            _context.prev = 6;
            _context.t0 = _context["catch"](0);
            console.error(_context.t0);
            throw _context.t0;
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 6]]);
    }));
    return _search.apply(this, arguments);
  }
  return {
    search: search,
    products: products
  };
}